module.exports = __webpack_public_path__ + "img/63000.fd64d5b9.jpg";